export default function About() {
  return (
    <main data-testid="about-page" className="max-w-[1000px] mx-auto px-6 md:px-10 py-16 md:py-24">
      <div className="label-xs text-espresso-light">Our story</div>
      <h1 className="mt-3 font-serif text-5xl md:text-7xl leading-[0.95] tracking-tight text-espresso">
        A specialist,<br/><span className="italic">obsessed with one dessert.</span>
      </h1>
      <div className="mt-14 space-y-8 text-espresso-light leading-relaxed text-lg max-w-2xl">
        <p>
          TIRAMISÙ &amp; Co. is a boutique dessert brand launching from Ghaziabad. We built it around a simple belief —
          that tiramisu, done properly, doesn't need to share the counter with a hundred other things.
        </p>
        <p>
          Every cup is layered by hand. Imported mascarpone. Single-origin espresso. Real cocoa.
          We don't rush it, and we don't scale it beyond what we can craft the same day it reaches you.
        </p>
        <p>
          We wanted tiramisu to feel like it belongs to everyday moments too — the late-night craving,
          the film at home, the small celebration that deserves something considered.
        </p>
        <p className="font-serif italic text-2xl text-espresso pt-4">
          One Spoon Closer to Happiness.
        </p>
      </div>
    </main>
  );
}
